import { types } from "mobx-state-tree";

export const StorageSyncModel = types
  .model({
    lastSynchronization: types.map(
      types.model({
        name: types.identifier,
        timestamp: types.maybeNull(types.number),
      })
    ),
  })
  .actions((self) => ({
    setLastSyncDate: (name: string, timestamp: number): void => {
      self.lastSynchronization.set(name, { name, timestamp });
    },
  }));
